export const DEPARTMENT_TYPE_BINFEN = '缤纷';
export const DEPARTMENT_TYPE_EXTERNAL = '外部';
